exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1JZGcxiD3OSyLVHYXuieBZ ._1Q0z4uviWHxhOHKKpWeYZB{padding:10px;vertical-align:middle;overflow:scroll}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_1JZGcxiD3OSyLVHYXuieBZ",
	"accessibilityHelpWidget": "_1Q0z4uviWHxhOHKKpWeYZB"
};